const mapGradesWithStudents = ({
  uploadedGrades,
  currentGrades,
  emailColumnIndex,
  gradeColumnIndex,
}) =>
  uploadedGrades.slice(1).reduce((accum, row) => {
    const currentGrade = currentGrades.find(
      (_grade) => _grade.email === row[emailColumnIndex]
    );

    if (currentGrade) {
      return [
        ...accum,
        {
          ...currentGrade,
          grade: row[gradeColumnIndex],
        },
      ];
    }

    return accum;
  }, []);

export default mapGradesWithStudents;
